import axios from 'axios';

// eslint-disable-next-line no-undef
const baseUrl = process.env.REACT_APP_API_URL;

export async function sendChatMessage(data) {
	try {
		const response = await axios.post(`${baseUrl}/api/chat`, data);
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				error: true,
				message: error.response.data.error,
				data: error.response.data,
			};
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchAllRecentChatMessages(data) {
	try {
		const response = await axios.post(`${baseUrl}/api/chats/history`, data);
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				error: true,
				message: error.response.data.error,
				data: error.response.data,
			};
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}

export async function fetchRecentChatMessage(data) {
	try {
		const response = await axios.post(`${baseUrl}/api/chat/history`, data);
		return response.data;
	} catch (error) {
		if (error.response) {
			return { error: true, message: error.response.data.error };
		} else {
			console.error('Something went wrong', error.message);
			return { error: true, message: error.message };
		}
	}
}
